import Layout from "../components/utils/layout";
import React from "react";
import Formatters from "../components/utils/formatters";


const MonthlyCompliance = () => {
    const screenId="MonthlyCompliance"
    const formatters = Formatters()
    const charts = {
        applications_and_approvals: {
            specialFormatters : {
                orders: formatters.int,
                orders_passed: formatters.int,
                fraud: formatters.int,
                num_activities: formatters.int,
                cum_orders: formatters.int,
                cum_orders_passed: formatters.int,
                cum_fraud: formatters.int
            }
        },
        transactions_monitoring : {
            specialFormatters : {
                date:formatters.isoDate,
                added_to_list:formatters.int,
                removed_from_list:formatters.int,
                suspended:formatters.int
            }
        },
        details_of_cards_lost_or_stolen : {
            specialFormatters : {
                month: formatters.isoDate,
                replacement: formatters.int
            }
        },
        fraud_stats_funding_fraud : {},
        fraud_stats_negative_balances : {},
        monitor_accounts : {},
        chargeback_details : {},
        suspended_accounts:{},
        is_this_card_active: {
            owner_id:formatters.account_id_link,
            card_id:formatters.card_id_link
        },
        loading_by_month : {},
        details_of_replacements : {},
        active_card_numbers : {},
        gps_vs_osper_status: {
            source: "live"
        },
        account_tags: {
            source: "live"
        },
        activated_cards_over_timeperiod: {},
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default MonthlyCompliance
